import React from 'react';
import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import UserProgressReport from '../../Reports/UserProgressReport';

export default function UserProgressPage(props) {
	return (
		<div>
			<Breadcrumb
				pageName={I18n.t('admin.user_progress')}
				category={I18n.t('admin.reports')}
			/>
			<UserProgressReport
				login_stats_endpoint={props.login_stats_endpoint}
				export_datatable_endpoint={props.export_datatable_endpoint}
				export_endpoint={props.export_endpoint}
				report={props.report}
			/>
		</div>
	);
}
